export enum TenantEnum {
  None = 0,
  UnitedState = 1,
  China = 2,
  Russia = 3,
}
